import { useEffect, ReactNode } from 'react';

import { useLoader } from './loader-context';

export const AutoHideLoader = ({ children }: { children: ReactNode }) => {
  const { hideLoader } = useLoader();

  useEffect(() => {
    const raf = requestAnimationFrame(() => {
      hideLoader();
    });

    return () => cancelAnimationFrame(raf);
  }, [hideLoader]);

  return <>{children}</>;
};
